/**
 * Campaign attribution: captures campaign_id from the URL into sessionStorage
 * on any page load where it's present, then tags the cart with _campaign_id
 * on every bundle add-to-cart for the rest of the tab session. This gives
 * last-touch, session-scoped attribution — a campaign link click attributes
 * that entire browsing session, not just the literal click where the param
 * is in the URL. Session resets when the tab closes, so a stale value from
 * a much earlier visit can't leak in.
 * Property is underscore-prefixed to stay hidden from customer-facing cart/checkout.
 */
(function () {
  const STORAGE_KEY = 'campaign_id';

  const urlCampaignId = new URLSearchParams(window.location.search).get('campaign_id');
  if (urlCampaignId) {
    sessionStorage.setItem(STORAGE_KEY, urlCampaignId);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.add-pack-to-cart')) return;

    const campaignId = sessionStorage.getItem(STORAGE_KEY) || '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { '_campaign_id': campaignId }
      })
    }).then(() => {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('bundle:peak-cart-refresh'));
      }, 1000);
    });
  });
})();